import React, { ComponentType, ReactElement } from "react";
import { useMapContext } from "@evergis/react";

export function withMapPainter<P>(Component: ComponentType<P>) {
  return (props: P): ReactElement => {
    const { painter } = useMapContext();

    return <Component {...props} painter={painter} />;
  };
}
